import React from 'react';
import { Link } from 'react-router-dom';
import { Cake, UserPlus, Award } from 'lucide-react';
import { appLinks, events, birthdays, newHires } from './data';
import { useApp } from './store';
function Card({
  title,
  children,
  action,
  actionTo
}: {
  title: string;
  children: React.ReactNode;
  action?: string;
  actionTo?: string;
}) {
  return <div className="bg-white rounded-xl border border-navy-100 p-5" data-id="element-750">
      <div className="flex items-center justify-between mb-4" data-id="element-751">
        <h3 className="text-base font-serif font-bold text-navy-900" data-id="element-752">
          {title}
        </h3>
        {action && actionTo && <Link to={actionTo} className="text-xs font-semibold text-gold-600 hover:text-gold-700 uppercase tracking-wide" data-id="element-753">
            {action}
          </Link>}
      </div>
      {children}
    </div>;
}
export function RightRail() {
  const {
    kudos
  } = useApp();
  return <aside className="space-y-6" aria-label="Highlights" data-id="element-754">
      {/* App launcher */}
      <Card title="Your Apps" action="All" actionTo="/apps" data-id="element-755">
        <div className="grid grid-cols-3 gap-3" data-id="element-756">
          {appLinks.slice(0, 6).map(app => <Link to="/apps" key={app.label} className="flex flex-col items-center gap-1.5 group" data-id="element-757">
              <span className={`w-12 h-12 rounded-xl ${app.color} text-white font-bold text-sm flex items-center justify-center group-hover:scale-105 transition-transform shadow-sm`} data-id="element-758">
                {app.initials}
              </span>
              <span className="text-[0.7rem] text-navy-600 font-medium" data-id="element-759">
                {app.label}
              </span>
            </Link>)}
        </div>
      </Card>

      {/* Events */}
      <Card title="Upcoming Events" action="Calendar" actionTo="/events" data-id="element-760">
        <ul className="space-y-3" data-id="element-761">
          {events.slice(0, 3).map(e => <li key={e.id} className="flex items-center gap-3" data-id="element-762">
              <div className="w-12 shrink-0 text-center bg-navy-50 rounded-lg py-1.5" data-id="element-763">
                <div className="text-base font-bold text-navy-900 leading-none" data-id="element-764">
                  {e.day}
                </div>
                <div className="text-[0.6rem] font-bold text-gold-600 tracking-wide" data-id="element-765">
                  {e.month}
                </div>
              </div>
              <div className="min-w-0" data-id="element-766">
                <p className="text-sm font-semibold text-navy-900 leading-snug truncate" data-id="element-767">
                  {e.title}
                </p>
                <p className="text-xs text-navy-400" data-id="element-768">
                  {e.time} · {e.type}
                </p>
              </div>
            </li>)}
        </ul>
      </Card>

      {/* Recognition */}
      <Card title="Recognition" action="Send" actionTo="/recognition" data-id="element-769">
        <ul className="space-y-3" data-id="element-770">
          {kudos.slice(0, 2).map(r => <li key={r.id} className="flex gap-3 text-sm" data-id="element-771">
              <div className="w-8 h-8 shrink-0 rounded-full bg-gold-100 flex items-center justify-center text-gold-600" data-id="element-772">
                <Award className="w-4 h-4" data-id="element-773" />
              </div>
              <p className="text-navy-700 leading-snug" data-id="element-774">
                <span className="font-semibold text-navy-900" data-id="element-775">{r.from}</span>{' '}
                recognized{' '}
                <span className="font-semibold text-navy-900" data-id="element-776">{r.to}</span>{' '}
                {r.message}
              </p>
            </li>)}
        </ul>
      </Card>

      {/* People */}
      <Card title="People" data-id="element-777">
        <div className="space-y-4" data-id="element-778">
          <div data-id="element-779">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-navy-400 mb-2" data-id="element-780">
              <Cake className="w-3.5 h-3.5 text-gold-500" data-id="element-781" /> Birthdays
            </p>
            <ul className="space-y-2" data-id="element-782">
              {birthdays.map(p => <li key={p.name} className="flex items-center gap-3" data-id="element-783">
                  <img src={p.avatar} alt="" className="w-8 h-8 rounded-full object-cover" data-id="element-784" />
                  <div className="min-w-0" data-id="element-785">
                    <p className="text-sm font-semibold text-navy-900 truncate" data-id="element-786">
                      {p.name}
                    </p>
                    <p className="text-xs text-navy-400" data-id="element-787">{p.detail}</p>
                  </div>
                </li>)}
            </ul>
          </div>
          <div data-id="element-788">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-navy-400 mb-2" data-id="element-789">
              <UserPlus className="w-3.5 h-3.5 text-sage" data-id="element-790" /> New Hires
            </p>
            <ul className="space-y-2" data-id="element-791">
              {newHires.map(p => <li key={p.name} className="flex items-center gap-3" data-id="element-792">
                  <img src={p.avatar} alt="" className="w-8 h-8 rounded-full object-cover" data-id="element-793" />
                  <div className="min-w-0" data-id="element-794">
                    <p className="text-sm font-semibold text-navy-900 truncate" data-id="element-795">
                      {p.name}
                    </p>
                    <p className="text-xs text-navy-400" data-id="element-796">{p.detail}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </Card>
    </aside>;
}